<template>
    <div class="skeleton-wrapper">
        <div class="avatar-skeleton-gs gs-skeleton-animation"></div>

        <div class="content">
            <div class="scene-row">
                <div class="scene-name-skeleton-gs gs-skeleton-animation"></div>
            </div>
            <div class="user-email-gs gs-skeleton-animation"></div>
        </div>
    </div>
</template>
